'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { NotificationIcon, NotificationsActiveIcon } from '../icons';
import styles from './StyledComponents.module.css';

interface ProductUpdatesToggleProps {
  /** The customer follows this card (an account row, or the guest memory). */
  active: boolean;
  onClick: () => void;
}

// The bell next to the wishlist heart: opens the product updates modal.
export const ProductUpdatesToggle: React.FC<ProductUpdatesToggleProps> = ({ active, onClick }) => {
  const t = useTranslations('product.productUpdates');
  const label = active ? t('bellOn') : t('bell');

  return (
    <button
      type="button"
      className={`${styles.updatesToggleIcon}${active ? ` ${styles.active}` : ''}`}
      onClick={onClick}
      aria-pressed={active}
      aria-label={label}
      title={label}
    >
      {active ? <NotificationsActiveIcon fontSize="small" /> : <NotificationIcon fontSize="small" />}
    </button>
  );
};
